import SEOHead from '@/components/SEOHead';
import BarHeroV2 from '@/components/marketing/bar/v2/BarHeroV2';
import BarProblemV2 from '@/components/marketing/bar/v2/BarProblemV2';
import BarHowItWorksV2 from '@/components/marketing/bar/v2/BarHowItWorksV2';
import BarCalculatorV2 from '@/components/marketing/bar/v2/BarCalculatorV2';
import BarPillarsV2 from '@/components/marketing/bar/v2/BarPillarsV2';
import BarFeatureModulesV2 from '@/components/marketing/bar/v2/BarFeatureModulesV2';
import BarOfflineV2 from '@/components/marketing/bar/v2/BarOfflineV2';
import BarForWhoV2 from '@/components/marketing/bar/v2/BarForWhoV2';
import BarComparisonV2 from '@/components/marketing/bar/v2/BarComparisonV2';
import BarPremiumV2 from '@/components/marketing/bar/v2/BarPremiumV2';
import BarFaqV2 from '@/components/marketing/bar/v2/BarFaqV2';
import { barFaqJsonLd } from '@/components/marketing/bar/v2/barFaqData';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

const BASE_URL = 'https://velko-pos.com';

const SOFTWARE_APP_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Velko Bar',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web, Windows, macOS, Linux, Android',
  url: `${BASE_URL}/velko-bar`,
  image: `${BASE_URL}/brand/og/og-bar.png`,
  inLanguage: 'fr',
  description:
    "Module premium de contrôle des coûts boissons pour bars et restaurants : recettes décimales, calcul du pour cost, consommation automatique à chaque vente, inventaire à l'aveugle et analyse d'écart en F CFA.",
  featureList: [
    'Recettes décimales et calcul du pour cost %',
    'Coût exact par boisson (par millilitre / par gramme)',
    'Consommation déduite automatiquement à chaque vente',
    "Inventaire à l'aveugle (blind count) anti-triche",
    "Rapport d'écart théorique vs réel valorisé en F CFA",
    'Détection du surdosage et du coulage',
    'Dashboards gérant et investisseur',
    'Fonctionnement hors ligne au comptoir',
  ],
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'XOF' },
  publisher: { '@type': 'Organization', name: 'Velko POS', url: BASE_URL },
};

export default function Bar() {
  return (
    <>
      <SEOHead
        title="Velko Bar — Logiciel de contrôle des coûts pour bars"
        description="Velko Bar : contrôle des coûts pour bars et restaurants. Recettes décimales, calcul du pour cost, consommation auto à chaque vente (même hors ligne), inventaire à l'aveugle, écart en F CFA, dashboards gérant & investisseur."
        path="/velko-bar"
        ogImage="/brand/og/og-bar.png"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Velko Bar', path: '/velko-bar' },
        ]}
        jsonLd={[SOFTWARE_APP_JSONLD, barFaqJsonLd()]}
      />

      <BarHeroV2 />
      <BarProblemV2 />
      <BarHowItWorksV2 />
      <BarCalculatorV2 />
      <BarPillarsV2 />
      <BarFeatureModulesV2 />
      <BarOfflineV2 />
      <BarForWhoV2 />
      <BarComparisonV2 />
      <BarPremiumV2 />
      <BarFaqV2 />
      <FinalCtaSection
        eyebrow="Reprends ta marge"
        title="Chaque verre compté."
        highlight="Chaque franc tracé."
        subtitle="Active Velko Bar et arrête de deviner. Le coût réel de tes boissons, l'écart en F CFA, le surdosage détecté — sur la caisse que tu utilises déjà."
        primaryLabel="Commencer gratuitement"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
        guarantees={['Module premium', 'Façon WISK', 'Hors ligne natif', 'Support FR']}
      />
    </>
  );
}
